import { FullScreenIcon, SearchIcon } from "@/icons";
import Button from "@/components/Button";
import { useEffect, useState } from "react";
import { FilterSpec } from "@/redux-store/slices/bookListStore";
import Input from "@/components/Input";
import { logopath } from "@/configs/appConfig";
interface BooksHeaderProps {
  filterSpec: FilterSpec;
  t: (key: string) => string;
  dispatch: (action: any) => void;
  setFilter: (filter: FilterSpec) => any;
}

const BooksHeader: React.FC<BooksHeaderProps> = ({
  filterSpec,
  t,
  dispatch,
  setFilter,
}) => {
  const [bookName, setBookName] = useState<string>("");
  const [isFullscreen, setIsFullscreen] = useState<boolean>(false);

  const handleBookNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBookName(event.target.value);
    dispatch(setFilter({ ...filterSpec, title: bookName || "" }));
  };

  useEffect(() => {
    if (bookName) {
      dispatch(setFilter({ ...filterSpec, title: bookName || "" }));
    }
  }, [bookName]);

  const setFullScreen = () => {
    !isFullscreen
      ? document.body.requestFullscreen()
      : document.exitFullscreen();

      setIsFullscreen(!isFullscreen);
  };


  return (
    <div className="page-header">
      <div className="header-logo">
        <img src={logopath} alt="Logo" />
      </div>
      <div className="header-content">
        <Input
          className="search-by-name"
          value={bookName}
          icon={<SearchIcon className={undefined} />}
          onChange={handleBookNameChange}
          placeholderText={t("book_name")}
          disablePasswordToggle={undefined}
          onClick={undefined}
          labelText={undefined}
          type={undefined}
          info={undefined}
          required={undefined}
          errorMessage={undefined}
        />

        <div className="flex">
          <Button
            className="obro-gray-btn"
            icon={<FullScreenIcon className={undefined} color={undefined} />}
            onClick={setFullScreen}
          >
            {t("full_screen")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BooksHeader;
